import { render, staticRenderFns } from "./CirculerLoader.vue?vue&type=template&id=b6c6c0c4&scoped=true&"
import script from "./CirculerLoader.vue?vue&type=script&lang=js&"
export * from "./CirculerLoader.vue?vue&type=script&lang=js&"
import style0 from "./CirculerLoader.vue?vue&type=style&index=0&id=b6c6c0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c6c0c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VOverlay,VProgressCircular})
